/**
 * Animated wave backdrop.
 *
 * A fixed full-viewport SVG with three layered wave paths. Each path is
 * twice as wide as the viewport and slides left forever via CSS animation,
 * giving an infinite scroll without JS. Colour follows --accent so the
 * waves switch with the light/dark theme.
 */

export function WaveBackground() {
  return (
    <div aria-hidden style={containerStyle}>
      <style>{KEYFRAMES}</style>
      <svg
        viewBox="0 0 1440 900"
        preserveAspectRatio="none"
        width="100%"
        height="100%"
      >
        <defs>
          <linearGradient id="wave-grad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="var(--wave-mid)" stopOpacity="0.18" />
            <stop offset="100%" stopColor="var(--wave-mid)" stopOpacity="0" />
          </linearGradient>
        </defs>

        <g className="eyesight-wave eyesight-wave-1">
          <path
            d="
              M 0 620
              Q 360 540, 720 620
              T 1440 620
              T 2160 620
              T 2880 620
              L 2880 900 L 0 900 Z
            "
            fill="url(#wave-grad)"
          />
        </g>

        <g className="eyesight-wave eyesight-wave-2">
          <path
            d="
              M 0 700
              Q 360 660, 720 700
              T 1440 700
              T 2160 700
              T 2880 700
              L 2880 900 L 0 900 Z
            "
            fill="var(--wave-mid)"
            opacity="0.10"
          />
        </g>

        <g className="eyesight-wave eyesight-wave-3">
          <path
            d="
              M 0 780
              Q 360 740, 720 780
              T 1440 780
              T 2160 780
              T 2880 780
              L 2880 900 L 0 900 Z
            "
            fill="var(--wave-mid)"
            opacity="0.07"
          />
        </g>
      </svg>
    </div>
  )
}

const containerStyle: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  zIndex: -1,
  pointerEvents: "none",
  overflow: "hidden",
}

const KEYFRAMES = `
@keyframes eyesight-wave-slide-1 {
  from { transform: translateX(0); }
  to { transform: translateX(-1440px); }
}
@keyframes eyesight-wave-slide-2 {
  from { transform: translateX(0); }
  to { transform: translateX(-1440px); }
}
@keyframes eyesight-wave-slide-3 {
  from { transform: translateX(0); }
  to { transform: translateX(-1440px); }
}
.eyesight-wave { will-change: transform; }
.eyesight-wave-1 {
  animation: eyesight-wave-slide-1 22s linear infinite;
}
.eyesight-wave-2 {
  animation: eyesight-wave-slide-2 32s linear infinite;
}
.eyesight-wave-3 {
  animation: eyesight-wave-slide-3 46s linear infinite;
}
@media (prefers-reduced-motion: reduce) {
  .eyesight-wave-1,
  .eyesight-wave-2,
  .eyesight-wave-3 { animation: none; }
}
`
